// import React, { useState } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   Box,
//   Button,
//   IconButton,
//   Drawer,
//   List,
//   ListItem,
//   ListItemText,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import { useNavigate } from "react-router-dom";

// const Navbar = ({ path }) => {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [activeSection, setActiveSection] = useState("home"); // Active Section State
//   const navigate = useNavigate();

//   const handleToggleDrawer = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   const handleClick = (id) => {
//     const element = document.getElementById(id);
//     if (element) {
//       element.scrollIntoView({ behavior: "smooth" });
//       setMobileOpen(false);
//       setActiveSection(id); // Set active section
//     }
//   };

//   const handleHome = () => {
//     navigate("/");
//     setActiveSection("home"); // Set Home as active
//   };

//   const handleLogin = () => {
//     navigate("/login");
//   };

//   const handleLogout = () => {
//     navigate("/");
//     sessionStorage.clear();
//   };

//   const sections = [
//     { id: "home", label: "Home" },
//     { id: "activities-events", label: "Activities & Events" },
//     { id: "watch-listen", label: "Watch/Listen" },
//     { id: "resources", label: "Resources" },
//     { id: "gallery", label: "Gallery" },
//     // { id: "become-member", label: "Become a Member / Join Us" },
//     { id: "get-involved", label: "Get Involved" },
//     { id: "contact-us", label: "Contact Us" },
//   ];

//   return (
//     <AppBar
//       position="fixed"
//       sx={{
//         backgroundColor: "#00adb5",
//         backgroundImage: "linear-gradient(147deg, #00adb5 0%, #6e48aa 74%)",
//         color: "#fff",
//       }}
//     >
//       <Toolbar>
//         {path !== "admin" && (
//           <IconButton
//             edge="start"
//             color="inherit"
//             aria-label="menu"
//             sx={{ display: { xs: "block", md: "none" } }}
//             onClick={handleToggleDrawer}
//           >
//             <MenuIcon />
//           </IconButton>
//         )}
//         <img
//           src="/images/YF_transparent.png"
//           alt="Logo"
//           className="img-fluid logo"
//           onClick={handleHome}
//           style={{ cursor: "pointer" }}
//         />
//         {path !== "admin" && (
//           <Box
//             sx={{
//               flexGrow: 1,
//               display: { xs: "none", md: "flex" },
//               justifyContent: "center",
//             }}
//           >
//             {sections.map((section) => (
//               <Typography
//                 key={section.id}
//                 sx={{
//                   margin: "0 15px",
//                   cursor: "pointer",
//                   display: "inline-block",
//                   fontWeight: activeSection === section.id ? "bold" : "normal", // Highlight active section
//                   color: activeSection === section.id ? "#ffeb3b" : "inherit", // Change color
//                   borderBottom:
//                     activeSection === section.id ? "2px solid #ffeb3b" : "none", // Underline active
//                 }}
//                 onClick={() => handleClick(section.id)}
//               >
//                 {section.label}
//               </Typography>
//             ))}
//           </Box>
//         )}

//         <Box sx={{ ml: "auto" }}>
//           {path !== "admin" ? (
//             <Button
//               variant="contained"
//               sx={{ background: "black", color: "white" }}
//               onClick={handleLogin}
//             >
//               Become a Member / Join Us
//             </Button>
//           ) : (
//             <Button variant="contained" color="error" onClick={handleLogout}>
//               Logout
//             </Button>
//           )}
//         </Box>
//       </Toolbar>

//       {/* Mobile Drawer */}
//       <Drawer anchor="left" open={mobileOpen} onClose={handleToggleDrawer}>
//         <List>
//           {sections.map((section) => (
//             <ListItem
//               button
//               key={section.id}
//               onClick={() => handleClick(section.id)}
//               sx={{
//                 backgroundColor:
//                   activeSection === section.id ? "#00adb5" : "inherit",
//                 color: activeSection === section.id ? "#fff" : "inherit",
//               }}
//             >
//               <ListItemText primary={section.label} />
//             </ListItem>
//           ))}
//         </List>
//       </Drawer>
//     </AppBar>
//   );
// };

// export default Navbar;
import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";

const Navbar = ({ path }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home"); // Active Section State
  const navigate = useNavigate();

  const handleToggleDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleClick = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMobileOpen(false);
      setActiveSection(id); // Set active section
    }
  };

  const handleHome = () => {
    navigate("/");
    setActiveSection("home"); // Set Home as active
  };

  const handleLogin = () => {
    navigate("/login");
  };

  const handleLogout = () => {
    navigate("/");
    sessionStorage.clear();
  };

  const sections = [
    { id: "home", label: "Home" },
    { id: "activities-events", label: "Activities & Events" },
    { id: "watch-listen", label: "Watch/Listen" },
    { id: "resources", label: "Resources" },
    { id: "gallery", label: "Gallery" },
    { id: "get-involved", label: "Get Involved" },
    { id: "contact-us", label: "Contact Us" },
  ];

  // Detect Active Section on Scroll
  useEffect(() => {
    const handleScroll = () => {
      let currentSection = "home"; // Default active section
      for (const section of sections) {
        const element = document.getElementById(section.id);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= window.innerHeight * 0.3 && rect.bottom >= 100) {
            currentSection = section.id;
          }
        }
      }
      setActiveSection(currentSection);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "#00adb5",
        backgroundImage: "linear-gradient(147deg, #00adb5 0%, #6e48aa 74%)",
        color: "#fff",
      }}
    >
      <Toolbar>
        {path !== "admin" && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ display: { xs: "block", md: "none" } }}
            onClick={handleToggleDrawer}
          >
            <MenuIcon />
          </IconButton>
        )}
        <img
          src="/images/YF_transparent.png"
          alt="Logo"
          className="img-fluid logo"
          onClick={handleHome}
          style={{ cursor: "pointer" }}
        />
        {path !== "admin" && (
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
            }}
          >
            {sections.map((section) => (
              <Typography
                key={section.id}
                sx={{
                  margin: "0 15px",
                  cursor: "pointer",
                  display: "inline-block",
                  fontWeight: activeSection === section.id ? "bold" : "normal", // Highlight active section
                  color: activeSection === section.id ? "#ffeb3b" : "inherit", // Change color
                  borderBottom:
                    activeSection === section.id ? "2px solid #ffeb3b" : "none", // Underline active
                }}
                onClick={() => handleClick(section.id)}
              >
                {section.label}
              </Typography>
            ))}
          </Box>
        )}

        <Box sx={{ ml: "auto" }}>
          {path !== "admin" ? (
            <Button
              variant="contained"
              sx={{
                background: "black",
                color: "white",
                whiteSpace: "nowrap", // Prevent text wrapping
                fontSize: { xs: "10px", sm: "12px", md: "14px" }, // Adjust font size
                padding: { xs: "4px 8px", sm: "6px 12px", md: "8px 16px" }, // Adjust padding
                minWidth: { xs: "auto", sm: "140px" }, // Prevents too large buttons
              }}
              onClick={handleLogin}
            >
              {/* Shorter text for small screens */}
              <Box
                component="span"
                sx={{ display: { xs: "inline", sm: "none" } }}
              >
                Join Us
              </Box>

              {/* Full text for larger screens */}
              <Box
                component="span"
                sx={{ display: { xs: "none", sm: "inline" } }}
              >
                Become a Member / Join Us
              </Box>
            </Button>
          ) : (
            <Button
              variant="contained"
              color="error"
              sx={{
                fontSize: { xs: "12px", sm: "14px" },
                padding: { xs: "5px 10px", sm: "8px 16px" },
              }}
              onClick={handleLogout}
            >
              Logout
            </Button>
          )}
        </Box>
      </Toolbar>

      {/* Mobile Drawer */}
      <Drawer anchor="left" open={mobileOpen} onClose={handleToggleDrawer}>
        <List>
          {sections.map((section) => (
            <ListItem
              button
              key={section.id}
              onClick={() => handleClick(section.id)}
              sx={{
                backgroundColor:
                  activeSection === section.id ? "#00adb5" : "inherit",
                color: activeSection === section.id ? "#fff" : "inherit",
              }}
            >
              <ListItemText primary={section.label} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
